import React, {
  useState,
  useEffect,
  useRef,
  useContext,
  useCallback,
  useMemo,
} from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./Fields.css";
import {
  FaPen,
  FaPlus,
  FaEdit,
  FaTrash,
  FaRegFileAlt,
  FaExclamationTriangle,
  FaLeaf,
} from "react-icons/fa";
import "leaflet/dist/leaflet.css";
import {
  MapContainer,
  TileLayer,
  Polygon,
  useMap,
  ImageOverlay,
} from "react-leaflet";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import { UserContext } from "../../UserContext";
import axios from "axios";
import toast from "react-hot-toast"; // Add this line

// --- Mock Data to support the detailed UI ---
// const mockData = {
//   id: 1,
//   name: "قاسم",
//   area: 0.8,
//   areaUnit: "Feddan",
//   group: "لا يوجد",
//   type: "--",
//   notes: "ارض مانجا",
//   boundaries: [
//     [31.2156, 29.9553],
//     [31.2166, 29.9553],
//     [31.2166, 29.9563],
//     [31.2156, 29.9563],
//   ],
//   // This 'plantations' array now has the correct nested 'crop' object
//   plantations: [
//     {
//       id: 1,
//       plantationDate: "2025-08-14",
//       expectedHarvestDate: "2025-12-12",
//       age: "20 أيام",
//       lastUpdate: "2025-08-12",
//       plantCount: 5000,
//       crop: {
//         id: 101,
//         name: "عباد الشمس",
//         category: "زيتي",
//       },
//     },
//     {
//       id: 2,
//       plantationDate: "2025-03-20",
//       expectedHarvestDate: "2025-08-20",
//       age: "145 أيام",
//       lastUpdate: "2025-08-10",
//       plantCount: 250,
//       crop: {
//         id: 102,
//         name: "مانجا",
//         category: "فاكهة",
//       },
//     },
//     {
//       id: 3,
//       plantationDate: "2025-02-15",
//       expectedHarvestDate: "2025-07-10",
//       age: "180 أيام",
//       lastUpdate: "2025-08-11",
//       plantCount: 1200,
//       crop: {
//         id: 103,
//         name: "قمح",
//         category: "حبوب",
//       },
//     },
//     {
//       id: 4,
//       plantationDate: "2025-05-01",
//       expectedHarvestDate: "2025-09-15",
//       age: "103 أيام",
//       lastUpdate: "2025-08-12",
//       plantCount: 800,
//       crop: {
//         id: 104,
//         name: "طماطم",
//         category: "خضروات",
//       },
//     },
//     {
//       id: 5,
//       plantationDate: "2025-06-10",
//       expectedHarvestDate: "2025-10-05",
//       age: "63 أيام",
//       lastUpdate: "2025-08-12",
//       plantCount: 1500,
//       crop: {
//         id: 105,
//         name: "ذرة",
//         category: "حبوب",
//       },
//     },
//     {
//       id: 6,
//       plantationDate: "2025-01-25",
//       expectedHarvestDate: "2025-06-30",
//       age: "200 أيام",
//       lastUpdate: "2025-08-10",
//       plantCount: 400,
//       crop: {
//         id: 106,
//         name: "بطاطس",
//         category: "خضروات",
//       },
//     },
//     {
//       id: 7,
//       plantationDate: "2025-04-05",
//       expectedHarvestDate: "2025-09-01",
//       age: "129 أيام",
//       lastUpdate: "2025-08-12",
//       plantCount: 600,
//       crop: {
//         id: 107,
//         name: "خيار",
//         category: "خضروات",
//       },
//     },
//     {
//       id: 8,
//       plantationDate: "2025-07-01",
//       expectedHarvestDate: "2025-11-20",
//       age: "72 أيام",
//       lastUpdate: "2025-08-12",
//       plantCount: 900,
//       crop: {
//         id: 108,
//         name: "فول سوداني",
//         category: "بقوليات",
//       },
//     },
//     {
//       id: 9,
//       plantationDate: "2025-02-01",
//       expectedHarvestDate: "2025-06-15",
//       age: "193 أيام",
//       lastUpdate: "2025-08-10",
//       plantCount: 300,
//       crop: {
//         id: 109,
//         name: "برتقال",
//         category: "فاكهة",
//       },
//     },
//     {
//       id: 10,
//       plantationDate: "2025-05-15",
//       expectedHarvestDate: "2025-09-30",
//       age: "90 أيام",
//       lastUpdate: "2025-08-12",
//       plantCount: 2000,
//       crop: {
//         id: 110,
//         name: "فلفل أحمر",
//         category: "خضروات",
//       },
//     },
//     {
//       id: 11,
//       plantationDate: "2025-03-10",
//       expectedHarvestDate: "2025-08-05",
//       age: "155 أيام",
//       lastUpdate: "2025-08-12",
//       plantCount: 450,
//       crop: {
//         id: 111,
//         name: "عنب",
//         category: "فاكهة",
//       },
//     },
//     {
//       id: 12,
//       plantationDate: "2025-06-20",
//       expectedHarvestDate: "2025-10-25",
//       age: "53 أيام",
//       lastUpdate: "2025-08-12",
//       plantCount: 1100,
//       crop: {
//         id: 112,
//         name: "بصل",
//         category: "خضروات",
//       },
//     },
//   ],
//   // Activities are linked to plantations by plantationId
//   activities: [
//     {
//       id: 101,
//       plantationId: 2,
//       title: "زراعة مانجا - (زراعة)",
//       date: "2025-08-20",
//       description: "مهمة زراعة",
//       status: "لم تبدأ",
//       assignee: "فارمر تعديل 2",
//     },
//     {
//       id: 102,
//       plantationId: 2,
//       title: "تسميد المانجا",
//       date: "2025-08-22",
//       description: "مهمة تسميد",
//       status: "انتهت",
//       assignee: "h.worker",
//     },
//     {
//       id: 103,
//       plantationId: 1,
//       title: "ري عباد الشمس",
//       date: "2025-08-15",
//       description: "مهمة ري",
//       status: "انتهت",
//       assignee: "h.worker",
//     },
//   ],
//   transactions: [
//     {
//       id: 101,
//       type: "expense",
//       description: "العمالة اليومية",
//       detail: "٣ عمال لمدة ٥ أيام للحصاد",
//       amount: 500.0,
//       date: "2025-01-20",
//       fieldName: " ١",
//     },
//     {
//       id: 102,
//       type: "income",
//       description: "بيع المحصول",
//       detail: "بيع جزء من محصول الذرة",
//       amount: 2500.0,
//       date: "2025-01-20",
//       fieldName: " ١",
//     },
//     {
//       id: 103,
//       type: "expense",
//       description: "الأسمدة",
//       detail: "شراء أسمدة نيتروجينية",
//       amount: 850.0,
//       date: "2025-01-18",
//       fieldName: " ١",
//     },
//   ],
//   // --- NEW: Mock data for the Satellite Tab Chart ---
//   satelliteData: {
//     NDVI: [
//       { date: "2025-07-20", value: 0.65 },
//       { date: "2025-07-27", value: 0.68 },
//       { date: "2025-08-06", value: 0.72 },
//       { date: "2025-08-08", value: 0.71 },
//       { date: "2025-08-10", value: 0.75 },
//       { date: "2025-08-12", value: 0.78 },
//     ],
//     NDMI: [
//       { date: "2025-07-20", value: 0.42 },
//       { date: "2025-07-27", value: 0.45 },
//       { date: "2025-08-06", value: 0.43 },
//       { date: "2025-08-08", value: 0.4 },
//       { date: "2025-08-10", value: 0.46 },
//       { date: "2025-08-12", value: 0.48 },
//     ],
//   },
// };

// --- FIX: Helper component to automatically fit the map to the given polygon bounds ---
const AutoFitBounds = ({ bounds }) => {
  const map = useMap();
  useEffect(() => {
    if (bounds && bounds.length > 0) {
      map.fitBounds(bounds, { padding: [50, 50] });
    }
  }, [bounds, map]);
  return null;
};

// --- Sub-components for each tab's content ---

const DeleteTransactionModal = ({
  isOpen,
  onClose,
  onConfirm,
  transaction,
}) => {
  const { t } = useTranslation();
  if (!isOpen) return null;
  return (
    <div className="transaction-delete-modal-overlay" onClick={onClose}>
      <div
        className="transaction-delete-modal-content"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="transaction-delete-modal-icon">
          <FaExclamationTriangle />
        </div>
        <h3>{t("Confirm Deletion")}</h3>
        <p>
          {t("Are you sure you want to delete the transaction")}:{" "}
          <strong>{transaction?.description}</strong>
          {t("questionMark")}
        </p>
        <div className="transaction-delete-modal-actions">
          <button className="button-secondary" onClick={onClose}>
            {t("Cancel")}
          </button>
          <button className="button-danger" onClick={onConfirm}>
            {t("Delete")}
          </button>
        </div>
      </div>
    </div>
  );
};

const DeleteModal = ({ isOpen, onClose, onConfirm, itemName }) => {
  const { t } = useTranslation();
  if (!isOpen) return null;

  return (
    <div className="field-delete-modal-overlay" onClick={onClose}>
      <div
        className="field-delete-modal-content"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="field-delete-modal-icon">
          <FaExclamationTriangle />
        </div>
        <h3>{t("Are you sure you want to delete?")}</h3>
        <p>
          {t(
            "This item may be linked to other items in the application, and they will also be deleted. By confirming the deletion, you will not be able to recover this data again."
          )}
        </p>
        <div className="field-delete-modal-actions">
          <button className="button-secondary" onClick={onClose}>
            {t("Cancel")}
          </button>
          <button className="button-danger" onClick={onConfirm}>
            {t("Delete")}
          </button>
        </div>
      </div>
    </div>
  );
};

// NEW DateRangeModal Component
const DateRangeModal = ({ isOpen, onClose, onConfirm }) => {
  const { t } = useTranslation();
  const [startDate, setStartDate] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [endDate, setEndDate] = useState(
    new Date().toISOString().split("T")[0]
  );

  if (!isOpen) return null;

  const handleConfirm = () => {
    onConfirm(startDate, endDate);
    onClose();
  };

  return (
    <div className="field-delete-modal-overlay" onClick={onClose}>
      <div
        className="date-range-modal-content"
        onClick={(e) => e.stopPropagation()}
      >
        <h3>{t("Select Custom Period")}</h3>
        <div className="form-row">
          <div className="form-group">
            <label htmlFor="startDate">{t("Start Date")}</label>
            <input
              type="date"
              id="startDate"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
            />
          </div>
          <div className="form-group">
            <label htmlFor="endDate">{t("End Date")}</label>
            <input
              type="date"
              id="endDate"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
            />
          </div>
        </div>
        <div className="date-range-modal-actions">
          <button type="button" className="button-secondary" onClick={onClose}>
            {t("Cancel")}
          </button>
          <button
            type="button"
            className="button-primary"
            onClick={handleConfirm}
          >
            {t("Confirm")}
          </button>
        </div>
      </div>
    </div>
  );
};

const DetailsTab = ({ field }) => {
  const { t } = useTranslation();
  return (
    <div className="overview-grid">
      <div className="info-item">
        <span className="info-label">{t("Area")}</span>
        <span className="info-value">{`${field.area} ${t(
          field.areaUnit
        )}`}</span>
      </div>
      <div className="info-item">
        <span className="info-label">{t("Group")}</span>
        <span className="info-value">{t(field.group)}</span>
      </div>
      <div className="info-item">
        <span className="info-label">{t("Type")}</span>
        <span className="info-value">{t(field.type)}</span>
      </div>
      <div className="info-item">
        <span className="info-label">{t("Notes")}</span>
        <span className="info-value">
          {field.notes || t("No notes available.")}
        </span>
      </div>
    </div>
  );
};

// =========================================================================
// === START: UPDATED SATELLITE TAB (BUG FIX, DYNAMIC LEGENDS & DESCRIPTIONS) ===
// =========================================================================

// --- Helper functions for dynamic descriptions and colors ---

const getNdviDetails = (value, t) => {
  const val = parseFloat(value);
  if (isNaN(val)) return { description: t("N/A"), color: "#333" };

  if (val >= 0.6)
    return { description: t("Very good healthy plant"), color: "#006400" };
  if (val >= 0.5)
    return { description: t("Good healthy plant"), color: "#228B22" };
  if (val >= 0.4) return { description: t("Moderate plant"), color: "#32CD32" };
  if (val >= 0.3) return { description: t("Weak plant"), color: "#ADFF2F" };
  if (val >= 0.2)
    return { description: t("Very weak plant"), color: "#FFFF00" };
  if (val >= 0.1) return { description: t("Dry soil"), color: "#FFA500" };
  return { description: t("Rocks or buildings"), color: "#FF0000" };
};

const getNdmiDetails = (value, t) => {
  const val = parseFloat(value);
  if (isNaN(val)) return { description: t("N/A"), color: "#333" };

  if (val >= 0.8)
    return {
      description: t("Total canopy cover, no water stress/waterlogging"),
      color: "#0D47A1",
    };
  if (val >= 0.6)
    return {
      description: t("Very high canopy cover, no water stress"),
      color: "#1565C0",
    };
  if (val >= 0.4)
    return {
      description: t("High canopy cover, no water stress"),
      color: "#1976D2",
    };
  if (val >= 0.2)
    return {
      description: t(
        "Mid-high canopy, high water stress or average canopy, low water stress"
      ),
      color: "#1E88E5",
    };
  if (val >= 0)
    return {
      description: t(
        "Average canopy, high water stress or mid-low canopy, low water stress"
      ),
      color: "#42A5F5",
    };
  if (val >= -0.2)
    return {
      description: t(
        "Mid-low canopy, high water stress or low canopy, low water stress"
      ),
      color: "#BCAAA4",
    };
  if (val >= -0.4)
    return {
      description: t("Low canopy cover (dry) or very low canopy cover (wet)"),
      color: "#A1887F",
    };
  if (val >= -0.6)
    return { description: t("Very low canopy cover"), color: "#8D6E63" };
  if (val >= -0.8)
    return { description: t("Almost absent canopy cover"), color: "#795548" };
  return { description: t("Bare soil"), color: "#5D4037" };
};

const SatelliteTab = ({ field }) => {
  const { t } = useTranslation();

  // --- Helper components ---
  const MapResizer = () => {
    const map = useMap();
    useEffect(() => {
      const timer = setTimeout(() => map.invalidateSize(), 100);
      return () => clearTimeout(timer);
    }, [map]);
    return null;
  };

  const MapLegend = ({ legend }) => {
    if (!legend) return null;
    return (
      <div className="leaflet-bottom leaflet-left">
        <div className="leaflet-control leaflet-bar map-legend-container">
          <span>{t(legend.minLabel)}</span>
          <div
            className="legend-gradient-bar"
            style={{ background: legend.gradient }}
          ></div>
          <span>{t(legend.maxLabel)}</span>
        </div>
      </div>
    );
  };

  const SatelliteChart = ({ data, indexName }) => {
    const formatXAxis = (tickItem) =>
      new Date(tickItem).toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
      });
    const formatYAxis = (tickItem) =>
      typeof tickItem === "number" ? tickItem.toFixed(2) : tickItem;

    const CustomTooltip = ({ active, payload, label }) => {
      if (active && payload && payload.length) {
        return (
          <div className="custom-chart-tooltip">
            <p className="tooltip-label">{formatXAxis(label)}</p>
            <p className="tooltip-intro">{`${indexName} : ${payload[0].value.toFixed(
              4
            )}`}</p>
          </div>
        );
      }
      return null;
    };

    return (
      <ResponsiveContainer width="100%" height={300}>
        <LineChart
          data={data}
          margin={{ top: 5, right: 30, left: 0, bottom: 5 }}
        >
          <CartesianGrid strokeDasharray="3 3" stroke="#e9ecef" />
          <XAxis dataKey="date" tickFormatter={formatXAxis} stroke="#666" />
          <YAxis
            domain={["dataMin - 0.1", "dataMax + 0.1"]}
            tickFormatter={formatYAxis}
            stroke="#666"
          />
          <Tooltip content={<CustomTooltip />} />
          <Legend wrapperStyle={{ paddingTop: "20px" }} />
          <Line
            type="monotone"
            dataKey="value"
            name={indexName}
            stroke="#c7356c"
            strokeWidth={2}
            activeDot={{ r: 8 }}
          />
        </LineChart>
      </ResponsiveContainer>
    );
  };

  const IndexSummaryCard = ({
    indexName,
    value,
    isActive,
    onClick,
    description,
    valueColor,
  }) => (
    <div
      className={`index-summary-card ${isActive ? "active" : ""}`}
      onClick={onClick}
    >
      <div className="index-header">
        <h5>{t(indexName)}</h5>
        <span className="index-value" style={{ color: valueColor }}>
          {value && !isNaN(parseFloat(value))
            ? parseFloat(value).toFixed(2)
            : "N/A"}
        </span>
      </div>
      <p className="index-description">{description}</p>
    </div>
  );

  // --- Component State ---
  const formatDateForAPI = (date) => date.toISOString().split("T")[0];

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [activeIndex, setActiveIndex] = useState("ndvi");
  const [ndviData, setNdviData] = useState(null);
  const [ndmiData, setNdmiData] = useState(null);

  const [activePeriod, setActivePeriod] = useState("Last Week");
  const [dateRange, setDateRange] = useState(() => {
    const endDate = new Date();
    const startDate = new Date();
    startDate.setDate(endDate.getDate() - 7);
    return {
      start: formatDateForAPI(startDate),
      end: formatDateForAPI(endDate),
    };
  });
  const [isModalOpen, setModalOpen] = useState(false);

  // --- Dynamic Legends based on Android code snippets ---
  const legends = useMemo(
    () => ({
      ndvi: {
        gradient:
          "linear-gradient(to right, #FF0000, #FFA500, #FFFF00, #ADFF2F, #32CD32, #228B22, #006400)",
        minLabel: "Unhealthy",
        maxLabel: "Very Healthy",
      },
      ndmi: {
        gradient:
          "linear-gradient(to right, #795548, #BCAAA4, #FFFFFF, #42A5F5, #1565C0, #0D47A1)",
        minLabel: "Very Dry",
        maxLabel: "Very Wet",
      },
    }),
    []
  );

  // --- Data Fetching Effect (fetches both indices) ---
  useEffect(() => {
    const fetchAllSatelliteData = async () => {
      if (!field || !field.boundaries || field.boundaries.length < 3) {
        setError(t("Field boundaries are not defined correctly."));
        setLoading(false);
        return;
      }
      setLoading(true);
      setError(null);

      const baseURL = "http://egrobots.com:8000/";
      const vertices = field.boundaries.flatMap((p) => [p[1], p[0]]); // lng, lat order
      const params = new URLSearchParams();
      vertices.forEach((v) => params.append("vertices", v));
      params.append("start", dateRange.start);
      params.append("end", dateRange.end);
      const headers = { "x-api-key": "EgRobots@2022" };

      const ndviPromise = axios.get(`${baseURL}ndvi`, { headers, params });
      const ndmiPromise = axios.get(`${baseURL}ndmi`, { headers, params });

      try {
        const results = await Promise.allSettled([ndviPromise, ndmiPromise]);
        console.log("results all ->", results);
        const ndviResult = results[0];
        if (ndviResult.status === "fulfilled" && ndviResult.value.data) {
          setNdviData(ndviResult.value.data);
        } else {
          setNdviData(null);
          console.error("NDVI fetch failed:", ndviResult.reason?.message);
        }

        const ndmiResult = results[1];
        if (ndmiResult.status === "fulfilled" && ndmiResult.value.data) {
          setNdmiData(ndmiResult.value.data);
        } else {
          setNdmiData(null);
          console.error("NDMI fetch failed:", ndmiResult.reason?.message);
        }

        if (results.every((res) => res.status === "rejected")) {
          throw new Error("Both NDVI and NDMI requests failed.");
        }
      } catch (err) {
        setError(t("Could not load satellite data. Please try again later."));
        toast.error(t("Failed to load satellite data."));
      } finally {
        setLoading(false);
      }
    };
    fetchAllSatelliteData();
  }, [field, dateRange, t]);

  // --- Event Handlers & Memoized Values ---
  const handlePeriodChange = (e) => {
    const period = e.target.value;
    setActivePeriod(period);

    if (period === "Custom Period") {
      setModalOpen(true);
      return;
    }
    const endDate = new Date();
    const startDate = new Date();
    if (period === "Last Week") startDate.setDate(endDate.getDate() - 7);
    if (period === "Last Two Weeks") startDate.setDate(endDate.getDate() - 14);
    if (period === "Last Month") startDate.setMonth(endDate.getMonth() - 1);
    setDateRange({
      start: formatDateForAPI(startDate),
      end: formatDateForAPI(endDate),
    });
  };

  const handleConfirmDateRange = (start, end) => {
    setDateRange({ start, end });
    setActivePeriod("Custom Period");
  };

  const imageOverlayBounds = useMemo(() => {
    if (!field || !field.boundaries || field.boundaries.length === 0)
      return null;
    const lats = field.boundaries.map((p) => p[0]);
    const lngs = field.boundaries.map((p) => p[1]);
    return [
      [Math.min(...lats), Math.min(...lngs)],
      [Math.max(...lats), Math.max(...lngs)],
    ];
  }, [field]);

  const center =
    field.boundaries && field.boundaries.length > 0
      ? field.boundaries.reduce(
          (acc, curr) => [
            acc[0] + curr[0] / field.boundaries.length,
            acc[1] + curr[1] / field.boundaries.length,
          ],
          [0, 0]
        )
      : [0, 0];

  const activeData = activeIndex === "ndvi" ? ndviData : ndmiData;
  const chartData =
    (activeIndex === "ndvi"
      ? activeData?.timeSeriesData
      : activeData?.timeSeries) || [];
  const hasData = chartData.length > 0;

  // Calculate details for cards
  const ndviDetails = getNdviDetails(ndviData?.ndviValue, t);
  const ndmiDetails = getNdmiDetails(ndmiData?.ndmiValue, t);

  return (
    <>
      <DateRangeModal
        isOpen={isModalOpen}
        onClose={() => setModalOpen(false)}
        onConfirm={handleConfirmDateRange}
      />
      <div className="satellite-layout-container">
        <div className="satellite-map-view">
          <MapContainer
            center={center}
            style={{ height: "100%", width: "100%" }}
            scrollWheelZoom={true}
            zoom={15}
          >
            <TileLayer
              url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
              attribution="&copy; Esri"
            />
            <Polygon
              positions={field.boundaries}
              pathOptions={{
                color: "white",
                fillColor: "transparent",
                weight: 2,
                dashArray: "5, 5",
              }}
            />
            {activeData?.imageUrl && imageOverlayBounds && (
              <ImageOverlay
                url={activeData.imageUrl}
                bounds={imageOverlayBounds}
                opacity={0.7}
                zIndex={10}
              />
            )}
            <AutoFitBounds bounds={field.boundaries} />
            <MapResizer />
            <MapLegend legend={legends[activeIndex]} />
          </MapContainer>
        </div>

        <div className="satellite-sidebar">
          <div className="sidebar-section">
            <label htmlFor="period-select">{t("Select Period")}</label>
            <div className="select-wrapper">
              <select
                id="period-select"
                value={activePeriod}
                onChange={handlePeriodChange}
              >
                <option value="Last Week">{t("Last Week")}</option>
                <option value="Last Two Weeks">{t("Last Two Weeks")}</option>
                <option value="Last Month">{t("Last Month")}</option>
                <option value="Custom Period">{t("Custom Period")}</option>
              </select>
            </div>
            <div className="date-range-display">{`${dateRange.start} / ${dateRange.end}`}</div>
          </div>
          <div className="sidebar-section">
            <IndexSummaryCard
              indexName="NDVI Index"
              value={ndviData?.ndviValue}
              valueColor={loading ? "#333" : ndviDetails.color}
              description={loading ? "..." : ndviDetails.description}
              isActive={activeIndex === "ndvi"}
              onClick={() => setActiveIndex("ndvi")}
            />
            <IndexSummaryCard
              indexName="Soil Moisture Index"
              value={ndmiData?.ndmiValue}
              valueColor={loading ? "#333" : ndmiDetails.color}
              description={loading ? "..." : ndmiDetails.description}
              isActive={activeIndex === "ndmi"}
              onClick={() => setActiveIndex("ndmi")}
            />
          </div>
        </div>

        <div className="satellite-chart-view full-width-chart">
          <h4>{`${t(activeIndex)} ${t("Change Over Time")}`}</h4>
          <div className="chart-placeholder">
            {loading ? (
              <p className="no-data-text">{t("Loading chart data...")}</p>
            ) : error ? (
              <p className="no-data-text page-message error">{error}</p>
            ) : hasData ? (
              <SatelliteChart
                data={chartData}
                indexName={activeIndex.toUpperCase()}
              />
            ) : (
              <p className="no-data-text">
                {t("No data available for the selected period.")}
              </p>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
// =======================================================================
// === END: UPDATED SATELLITE TAB                                  ===
// =======================================================================

// =========================================================================
// === START: UPDATED DEPRECIATION TAB COMPONENT ===
// =========================================================================
const DepreciationTab = ({ fieldId, farmId, token }) => {
  const { t, i18n } = useTranslation();
  const [isModalOpen, setModalOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [depreciationData, setDepreciationData] = useState([]);
  const [error, setError] = useState(null);
  const [activePeriod, setActivePeriod] = useState("Last Year");
  const [dateRange, setDateRange] = useState({ start: null, end: null });

  useEffect(() => {
    // Set initial date range for "Last Year" on component mount
    const endDate = new Date();
    const startDate = new Date();
    startDate.setFullYear(endDate.getFullYear() - 1);
    setDateRange({
      start: startDate.getTime(),
      end: endDate.getTime(),
    });
  }, []);

  useEffect(() => {
    const fetchDepreciationData = async () => {
      if (!farmId || !fieldId || !token || !dateRange.start) return;

      setLoading(true);
      setError(null);

      try {
        const params = new URLSearchParams({ fieldId });
        params.append("startDate", dateRange.start);
        params.append("endDate", dateRange.end);

        // API Call: GET /api/inventoryMovements/findByFarmId/{farmId} [cite: 670]
        const response = await axios.get(
          `api/inventoryMovements/findByFarmId/${farmId}`,
          {
            headers: { Authorization: token },
            params: params,
          }
        );

        // const response = {
        //   status: 200,
        //   message: "InventoryMovements of farm fetched successfully.",
        //   items: [
        //     {
        //       InventoryMovements: {
        //         Distributions: [
        //           {
        //             InventoryItemDetails: {
        //               id: 38,
        //               typeId: 13,
        //               locationId: 843,
        //               tenantId: 15,
        //               farmId: 55,
        //               fieldId: null,
        //               spanId: null,
        //               nameEn: "ان بي كي",
        //               nameAr: "ان بي كي",
        //               registrationNumber: "2345677",
        //               details: "hggxbnmk",
        //               producer: "Abc",
        //               unit: "Kg",
        //               initialBalance: null,
        //               threshold: null,
        //               imagesUrls: null,
        //               createTs: "2024-02-24T21:05:20Z",
        //               updateTs: "2025-08-20T09:32:18Z",
        //               expirationDate: null,
        //             },
        //             inventoryType: {
        //               id: 13,
        //               tenantId: 15,
        //               farmId: 55,
        //               nameEn: "General",
        //               nameAr: "عام",
        //               createTs: "2023-10-03T15:33:23Z",
        //               updateTs: "2023-10-03T15:33:23Z",
        //             },
        //             Distribution: {
        //               id: 12,
        //               invoiceId: null,
        //               inventoryItemDetailId: 38,
        //               tenantId: 15,
        //               farmId: 55,
        //               fieldId: 75,
        //               clientId: null,
        //               quantity: 20,
        //               distributionDate: 1708290350865,
        //               createTs: "2024-02-24T21:05:55Z",
        //               updateTs: "2024-02-24T21:05:55Z",
        //               locationId: null,
        //             },
        //           },
        //         ],
        //       },
        //     },
        //   ],
        //   totalCount: 0,
        //   timestamp: "2025-08-20T09:39:34.044+00:00",
        // };
        console.log("response =", response.data);
        if (response.data && response.data.items) {
          const allDistributions = response.data.items.flatMap(
            (item) => item.InventoryMovements?.Distributions || []
          );

          const groupedData = allDistributions.reduce((acc, current) => {
            const itemDetails = current.InventoryItemDetails;
            const distribution = current.Distribution;
            if (!itemDetails || !distribution) return acc;

            const id = itemDetails.id;
            if (!acc[id]) {
              acc[id] = {
                id: id,
                name:
                  i18n.language === "ar"
                    ? itemDetails.nameAr
                    : itemDetails.nameEn,
                unit: itemDetails.unit,
                totalQuantity: 0,
              };
            }
            acc[id].totalQuantity += distribution.quantity;
            return acc;
          }, {});

          const processedData = Object.values(groupedData);
          console.log("processed data", processedData);
          setDepreciationData(processedData);
        }
      } catch (err) {
        console.error("Failed to fetch depreciation data:", err);
        setError(t("Failed to load usage data."));
        toast.error(t("Failed to load usage data."));
      } finally {
        setLoading(false);
      }
    };

    fetchDepreciationData();
  }, [farmId, fieldId, token, dateRange, t, i18n.language]);

  const handlePeriodChange = (e) => {
    const period = e.target.value;
    setActivePeriod(period);

    if (period === "Custom Period") {
      setModalOpen(true);
      return;
    }

    const endDate = new Date();
    let startDate = new Date();

    if (period === "Today") {
      startDate.setHours(0, 0, 0, 0);
    } else if (period === "Last Week") {
      startDate.setDate(endDate.getDate() - 7);
    } else if (period === "Last Month") {
      startDate.setMonth(endDate.getMonth() - 1);
    } else if (period === "Last Year") {
      startDate.setFullYear(endDate.getFullYear() - 1);
    }

    setDateRange({
      start: startDate.getTime(),
      end: endDate.getTime(),
    });
  };

  const handleConfirmDateRange = (start, end) => {
    // Convert string dates to timestamps
    const startDate = new Date(start);
    startDate.setHours(0, 0, 0, 0); // Start of the day
    const endDate = new Date(end);
    endDate.setHours(23, 59, 59, 999); // End of the day

    setDateRange({
      start: startDate.getTime(),
      end: endDate.getTime(),
    });
    setActivePeriod("Custom Period");
  };

  const renderContent = () => {
    if (loading) {
      return <div className="page-message">{t("Loading usage data...")}</div>;
    }
    if (error) {
      return <div className="page-message error">{error}</div>;
    }
    if (depreciationData.length === 0) {
      return (
        <div className="placeholder-tab">
          <div className="placeholder-icon">
            <FaRegFileAlt />
          </div>
          <h3>{t("No Data Available")}</h3>
          <p>{t("There is no consumption data for the selected period.")}</p>
        </div>
      );
    }
    return (
      <div className="depreciation-list">
        {depreciationData.map((item) => (
          <div key={item.id} className="depreciation-item">
            <span className="depreciation-item-name">{item.name}</span>
            <span className="depreciation-item-usage">{`${item.totalQuantity.toFixed(
              1
            )} ${t(item.unit)}`}</span>
          </div>
        ))}
      </div>
    );
  };

  return (
    <>
      <DateRangeModal
        isOpen={isModalOpen}
        onClose={() => setModalOpen(false)}
        onConfirm={handleConfirmDateRange}
      />
      <div className="depreciation-tab-content">
        <div className="depreciation-controls">
          <span className="depreciation-label">{t("Usage")}</span>
          <div className="form-group">
            <select value={activePeriod} onChange={handlePeriodChange}>
              <option value={"Today"}>{t("Today")}</option>
              <option value={"Last Week"}>{t("Last Week")}</option>
              <option value={"Last Month"}>{t("Last Month")}</option>
              <option value={"Last Year"}>{t("Last Year")}</option>
              <option value={"Custom Period"}>{t("Custom Period")}</option>
            </select>
          </div>
        </div>
        {renderContent()}
      </div>
    </>
  );
};
// =========================================================================
// === END: UPDATED DEPRECIATION TAB COMPONENT ===
// =========================================================================

const CropsTab = ({ fieldId, token }) => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();

  // --- HOOKS MOVED TO TOP LEVEL ---
  const cropCardsRef = useRef([]);
  const compositionCardsRef = useRef([]);
  const [plantations, setPlantations] = useState([]);
  const [activities, setActivities] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);
  const [selectedPlantation, setSelectedPlantation] = useState(null);

  // Reusable data fetching function
  const fetchData = useCallback(async () => {
    if (!fieldId || !token) {
      setLoading(false);
      return;
    }
    setLoading(true);
    setError(null);
    try {
      const [plantationsRes, activitiesRes] = await Promise.all([
        axios.get(`api/plantation/findByFieldId/${fieldId}`, {
          headers: { Authorization: token },
        }),
        axios.get(`api/task/findByFieldId/${fieldId}`, {
          headers: { Authorization: token },
        }),
      ]);
      console.log("=== PLANTATION API TEST ===");
      console.log("API Response:", plantationsRes.data);
      console.log("Plantations found:", plantationsRes.data.items?.length || 0);
      console.log("First plantation example:", plantationsRes.data.items?.[0]);
      console.log("=== END PLANTATION TEST ===");
      console.log("tasks data overall ->", activitiesRes);
      setPlantations(plantationsRes.data.items || []);
      setActivities(activitiesRes.data.items || []);
    } catch (err) {
      console.error("Failed to fetch crops tab data:", err);
      const errorMessage = t("Failed to load crop and activity data.");
      setError(errorMessage);
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  }, [fieldId, token, t]);

  // Fetch data when the component mounts or its dependencies change
  useEffect(() => {
    fetchData();
  }, [fetchData]);

  // This useEffect sets up the IntersectionObserver for the top crop cards
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
          }
        });
      },
      { root: null, threshold: 0 }
    );
    const currentCards = cropCardsRef.current;
    currentCards.forEach((card) => {
      if (card) observer.observe(card);
    });
    return () => {
      currentCards.forEach((card) => {
        if (card) observer.unobserve(card);
      });
    };
  }, [plantations]);

  // This useEffect sets up a separate observer for the composition cards
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
          }
        });
      },
      { root: null, threshold: 0 }
    );
    const currentCards = compositionCardsRef.current;
    currentCards.forEach((card) => {
      if (card) observer.observe(card);
    });
    return () => {
      currentCards.forEach((card) => {
        if (card) observer.unobserve(card);
      });
    };
  }, [plantations]);

  // --- HANDLERS AND HELPER FUNCTIONS ---
  const handleAddCrop = () => {
    navigate(`/fields/${fieldId}/plantations/new`);
  };

  const handleEditCrop = (plantationId) => {
    navigate(`/fields/${fieldId}/plantations/${plantationId}/edit`);
  };

  const handleDeleteCrop = (plantation) => {
    setSelectedPlantation(plantation);
    setDeleteModalOpen(true);
  };

  const handleConfirmDelete = async () => {
    if (!selectedPlantation || !token) return;
    try {
      // API Call: DELETE /api/plantation/{id} [cite: 331]
      await axios.delete(`api/plantation/${selectedPlantation.id}`, {
        headers: { Authorization: token },
      });
      toast.success(t("Crop cycle deleted."));
      fetchData(); // Refetch data locally
    } catch (error) {
      console.error("Failed to delete plantation:", error);
      toast.error(t("Failed to delete crop cycle."));
    } finally {
      setDeleteModalOpen(false);
      setSelectedPlantation(null);
    }
  };

  const handleCloseModal = () => {
    setDeleteModalOpen(false);
    setSelectedPlantation(null);
  };

  const calculateAge = (plantationTimestamp) => {
    if (!plantationTimestamp) return "--";
    const plantationDate = new Date(plantationTimestamp);
    const today = new Date();

    plantationDate.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);

    if (plantationDate > today) return t("Future Planting");

    const diffTime = Math.abs(today - plantationDate);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    return `${diffDays} ${t("days", { count: diffDays })}`;
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const day = date.getDate();
    const year = date.getFullYear();
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    const monthName = t(monthNames[date.getMonth()]);
    return `${day} ${monthName} ${year}`;
  };

  // Mapping from the API status text to the text used in your component
  const apiStatusMap = {
    notStarted: "لم تبدأ",
    inProgress: "جاري التنفيذ",
    finished: "انتهت",
  };

  // Mapping from the status text in your data to the CSS class name
  const statusClassMap = {
    انتهت: "status-finished",
    "لم تبدأ": "status-not-started",
    "جاري التنفيذ": "status-in-progress",
  };

  // --- CONDITIONAL RETURNS (NOW AFTER ALL HOOKS) ---
  if (loading) {
    return (
      <div className="page-message">{t("Loading Crops & Activities...")}</div>
    );
  }

  if (error) {
    return <div className="page-message error">{error}</div>;
  }

  // --- RENDER LOGIC ---
  return (
    <>
      <DeleteModal
        isOpen={isDeleteModalOpen}
        onClose={handleCloseModal}
        onConfirm={handleConfirmDelete}
        itemName={
          selectedPlantation?.crop?.nameEn || selectedPlantation?.crop?.nameAr
        }
      />
      <div className="crops-tab-container">
        {/* --- Crops Section --- */}
        <div className="crops-section">
          <div className="activities-header">
            <h3 className="section-title" style={{ marginBottom: 0 }}>
              {t("Crops")}
            </h3>
            <button className="button-outline-subtle" onClick={handleAddCrop}>
              <FaPlus /> {t("Add Crop")}
            </button>
          </div>
          <div className="horizontal-scroll-container">
            {plantations && plantations.length > 0 ? (
              plantations.map((p, index) => (
                <div
                  key={p.id}
                  className="crop-card"
                  ref={(el) => (cropCardsRef.current[index] = el)}
                >
                  <div className="crop-card-header">
                    <div className="crop-item-dates">
                      {t("From")} {formatDate(p.plantationDate)} {t("To")}{" "}
                      {formatDate(p.expectedHarvestDate)}
                    </div>
                    <div className="crop-item-actions">
                      <FaEdit onClick={() => handleEditCrop(p.id)} />
                      <FaTrash onClick={() => handleDeleteCrop(p)} />
                    </div>
                  </div>
                  <div className="crop-card-body">
                    <FaLeaf />
                    <span>
                      {i18n.language === "ar" ? p.crop?.nameAr : p.crop?.nameEn}
                    </span>
                  </div>
                </div>
              ))
            ) : (
              <p className="no-data-message"></p>
            )}
          </div>
        </div>

        {/* --- Activities Section --- */}
        <div className="activities-section">
          <div className="activities-header">
            <h3 className="section-title" style={{ marginBottom: 0 }}>
              {t("Activities")}
            </h3>
            <button
              className="button-outline-subtle"
              onClick={() => navigate(`/fields/${fieldId}/tasks/new`)}
            >
              <FaPlus /> {t("Add Activity")}
            </button>
          </div>
          <div className="activities-list">
            {activities && activities.length > 0 ? (
              activities.map((activity) => {
                if (!activity.task) return null;
                const statusText =
                  apiStatusMap[activity.task.state] || activity.task.state;
                return (
                  <div
                    key={activity.task.id}
                    onClick={() =>
                      navigate(`/fields/${fieldId}/tasks/${activity.task.id}`)
                    }
                    style={{ cursor: "pointer" }}
                  >
                    <div className="activity-item">
                      <div className="activity-info-right">
                        <h5>
                          {activity.task.name}{" "}
                          {activity.taskCategory && (
                            <span className="activity-category">
                              {"("}
                              {i18n.language === "ar"
                                ? activity.taskCategory.nameAr
                                : activity.taskCategory.nameEn}
                              {")"}
                            </span>
                          )}
                        </h5>
                        <p>{activity.task.textDesc}</p>
                        {activity.employee && (
                          <div className="activity-assignee">
                            {activity.employee.username}
                          </div>
                        )}
                      </div>
                      <div className="activity-info-left">
                        <span className="activity-date">
                          {new Date(activity.task.fromDate).toLocaleDateString(
                            "ar-EG",
                            {
                              day: "numeric",
                              month: "long",
                              year: "numeric",
                            }
                          )}
                        </span>
                        <div
                          className={`activity-status-badge ${
                            statusClassMap[statusText] || "status-not-started"
                          }`}
                        >
                          {t(statusText)}
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })
            ) : (
              <p className="no-data-message">{t("")}</p>
            )}
          </div>
        </div>
        {/* --- Crop Composition Section --- */}
        <div className="composition-section-wrapper">
          <h3 className="section-title">{t("Crop Composition")}</h3>
          <div className="horizontal-scroll-container">
            {plantations && plantations.length > 0 ? (
              plantations.map((p, index) => (
                <div
                  key={p.id}
                  className="composition-card"
                  ref={(el) => (compositionCardsRef.current[index] = el)}
                >
                  <div className="composition-header">
                    {i18n.language === "ar" ? p.crop?.nameAr : p.crop?.nameEn}
                  </div>
                  <div className="composition-details-grid">
                    <div className="composition-detail-item">
                      <span className="label">{t("Planting Date")}</span>
                      <span className="value">
                        {formatDate(p.plantationDate)}
                      </span>
                    </div>
                    <div className="composition-detail-item">
                      <span className="label">{t("Age")}</span>
                      <span className="value">
                        {calculateAge(p.plantationDate)}
                      </span>
                    </div>
                    <div className="composition-detail-item">
                      <span className="label">{t("Last Update")}</span>
                      <span className="value">
                        {formatDate(p.updateTs) || "--"}
                      </span>
                    </div>
                    <div className="composition-detail-item">
                      <span className="label">{t("Number of Plants")}</span>
                      <span className="value">{p.plantCount || "--"}</span>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <p className="no-data-message"></p>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

const FinancialsTab = ({ fieldId, token }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  // Internal state for data, loading, and errors
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);
  const [selectedTransaction, setSelectedTransaction] = useState(null);

  // Reusable data fetching function
  const fetchTransactions = useCallback(async () => {
    if (!fieldId || !token) {
      setLoading(false);
      return;
    }
    setLoading(true);
    setError(null);
    try {
      const res = await axios.get(`api/payment/findByFieldId/${fieldId}`, {
        headers: { Authorization: token },
      });
      setTransactions(res.data.items || []);
    } catch (err) {
      console.error("Failed to fetch transactions:", err);
      const errorMessage = t("Failed to load financial transactions.");
      setError(errorMessage);
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  }, [fieldId, token, t]);

  // Fetch data when component mounts
  useEffect(() => {
    fetchTransactions();
  }, [fetchTransactions]);

  const handleAdd = (type) => {
    navigate(`/fields/${fieldId}/transactions/new`, { state: { type: type } });
  };

  // The handleEdit function now expects the nested 'payment' object
  const handleEdit = (payment) => {
    console.log(payment);
    navigate(`/fields/${fieldId}/transactions/${payment.id}/edit`, {
      state: { transaction: payment },
    });
  };

  const handleDelete = (transaction) => {
    setSelectedTransaction(transaction);
    setDeleteModalOpen(true);
  };

  const handleDeleteConfirmTransaction = async () => {
    if (!selectedTransaction?.payment || !token) return;
    try {
      await axios.delete(`api/payment/${selectedTransaction.payment.id}`, {
        headers: { Authorization: token },
      });
      toast.success(t("Transaction deleted successfully."));
      fetchTransactions(); // Refetch data locally
    } catch (error) {
      console.error("Failed to delete transaction:", error);
      toast.error(t("Failed to delete transaction."));
    } finally {
      setDeleteModalOpen(false);
    }
  };

  // Add loading and error states to the UI
  if (loading) {
    return <div className="page-message">{t("Loading Transactions...")}</div>;
  }

  if (error) {
    return <div className="page-message error">{error}</div>;
  }

  // Update calculations to use the nested 'payment' object and API's 'type' enum
  const totalIncome = transactions
    .filter((t) => t.payment.type === "sale") // Check for 'sale' type
    .reduce((sum, t) => sum + t.payment.amountPaid, 0); // Sum 'amountPaid'

  const totalExpense = transactions
    .filter((t) => t.payment.type === "purchase") // Check for 'purchase' type
    .reduce((sum, t) => sum + t.payment.amountPaid, 0); // Sum 'amountPaid'

  const profit = totalIncome - totalExpense;

  return (
    <div>
      <DeleteTransactionModal
        isOpen={isDeleteModalOpen}
        onClose={() => setDeleteModalOpen(false)}
        onConfirm={handleDeleteConfirmTransaction}
        transaction={selectedTransaction?.payment} // Pass the nested payment object to the modal
      />
      <div className="financials-summary">
        <div className="summary-box">
          <span className="summary-label">{t("Profit")}</span>
          <span className="summary-value profit">{profit.toFixed(2)} +</span>
        </div>
        <div className="summary-box">
          <span className="summary-label">{t("Income")}</span>
          <span className="summary-value income">
            {totalIncome.toFixed(2)} +
          </span>
        </div>
        <div className="summary-box">
          <span className="summary-label">{t("Expenses")}</span>
          <span className="summary-value expense">
            {totalExpense.toFixed(2)} -
          </span>
        </div>
      </div>
      <div className="tab-actions">
        <button
          className="button-outline expense"
          onClick={() => handleAdd("expense")}
        >
          <FaPlus /> {t("Add Expense")}
        </button>
        <button
          className="button-outline income"
          onClick={() => handleAdd("income")}
        >
          <FaPlus /> {t("Add Income")}
        </button>
      </div>
      <div className="transaction-list">
        {transactions.map((item) => {
          // Determine the UI type ('income' or 'expense') from the API type ('sale' or 'purchase')
          const uiType = item.payment.type === "sale" ? "income" : "expense";

          return (
            <div key={item.payment.id} className="transaction-item">
              {" "}
              {/* Use nested ID for the key */}
              <div className="transaction-details">
                <h4>{t(item.payment.category)}</h4>{" "}
                {/* Access nested description */}
                <p>
                  {item.payment.description}{" "}
                  {/* Use category from the payment object */}
                  <br />
                  {/* Access the field name directly from the response */}
                  {t("Field")} {item.field.name} -{" "}
                  {new Date(item.payment.paymentDate).toLocaleDateString()}{" "}
                  {/* Access nested paymentDate */}
                </p>
              </div>
              <div className="transaction-amount">
                <span className={`amount-${uiType}`}>
                  {" "}
                  {/* Use the determined UI type for styling */}
                  {uiType === "income" ? "+" : "-"}
                  {item.payment.amountPaid.toFixed(2)}{" "}
                  {/* Access nested amountPaid */}
                </span>
                <div className="transaction-actions">
                  <FaEdit
                    className="action-icon"
                    onClick={() => handleEdit(item.payment)} // Pass the payment object to edit
                  />
                  <FaTrash
                    className="action-icon"
                    onClick={() => handleDelete(item)} // Pass the whole item for deletion
                  />
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

const FieldDetails = () => {
  const { t } = useTranslation();
  const { fieldId } = useParams();
  const navigate = useNavigate();
  const { token } = useContext(UserContext);
  const [field, setField] = useState(null);
  const [activeTab, setActiveTab] = useState("crops"); // Default to details
  const [loading, setLoading] = useState(true);
  const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);

  //   fetch mock data
  //   useEffect(() => {
  //     // In a real app, you would fetch data by fieldId.
  //     // Here we use mock data for demonstration.
  //     setField(mockData);
  //     setLoading(false);
  //   }, [fieldId]);

  const parseCustomLocationString = (locationString) => {
    if (!locationString || typeof locationString !== "string") {
      return [];
    }

    // This regex splits on a hyphen (-) only if it's preceded by a digit (\\d).
    // This correctly separates coordinate pairs without breaking negative numbers.
    const pairs = locationString.split(/(?<=\d)-/g);

    return pairs
      .map((pair) => pair.split(",").map(Number)) // Convert pairs to [lat, lng] arrays
      .filter(
        (
          coords // Filter out any invalid pairs as a safeguard
        ) =>
          Array.isArray(coords) &&
          coords.length === 2 &&
          !isNaN(coords[0]) &&
          !isNaN(coords[1])
      );
  };

  //  fetch real data from api
  //   useEffect(() => {
  //     const fetchFieldData = async () => {
  //       // Ensure we have the necessary ID and token before fetching
  //       if (!fieldId || !token) {
  //         setLoading(false);
  //         return;
  //       }
  //       setLoading(true);

  //       try {
  //         // Call the API to get the details for a single field
  //         const response = await axios.get(`api/field/${fieldId}`, {
  //           headers: {
  //             Authorization: `${token}`,
  //           },
  //         });
  //         console.log("field details response -> ", response);
  //         if (response.data.items && response.data.items.length > 0) {
  //           const fieldDataFromApi = response.data.items[0];

  //           // The API provides boundaries as a string in the 'location' field.
  //           // We must parse it into an array for the map component.
  //           const boundaries = parseCustomLocationString(
  //             fieldDataFromApi.location
  //           );

  //           // Combine the API data with the parsed boundaries for our component's state
  //           const completeFieldData = {
  //             ...fieldDataFromApi,
  //             boundaries: boundaries,
  //           };

  //           setField(completeFieldData);
  //         } else {
  //           throw new Error("Field not found.");
  //         }
  //       } catch (error) {
  //         console.error("Failed to fetch field details:", error);
  //         alert("Could not load field data.");
  //         navigate("/fields");
  //       } finally {
  //         setLoading(false);
  //       }
  //     };

  //     fetchFieldData();
  //   }, [fieldId, token, navigate]); // The effect depends on these values

  // Keep the useCallback functions for on-demand refetching from child components
  // const fetchPlantations = useCallback(async () => {
  //   if (!fieldId || !token) return;
  //   try {
  //     const res = await axios.get(`api/plantation/findByFieldId/${fieldId}`, {
  //       headers: { Authorization: token },
  //     });
  //     setPlantations(res.data.items || []);
  //   } catch (error) {
  //     console.error("Failed to refetch plantations", error);
  //   }
  // }, [fieldId, token]);

  // const fetchActivities = useCallback(async () => {
  //   if (!fieldId || !token) return;
  //   try {
  //     const res = await axios.get(`api/task/findByFieldId/${fieldId}`, {
  //       headers: { Authorization: token },
  //     });
  //     setActivities(res.data.items || []);
  //   } catch (error) {
  //     console.error("Failed to refetch activities", error);
  //   }
  // }, [fieldId, token]);

  // const fetchTransactions = useCallback(async () => {
  //   if (!fieldId || !token) return;
  //   try {
  //     const res = await axios.get(`api/payment/findByFieldId/${fieldId}`, {
  //       headers: { Authorization: token },
  //     });
  //     setTransactions(res.data.items || []);
  //   } catch (error) {
  //     console.error("Failed to refetch transactions", error);
  //   }
  // }, [fieldId, token]);

  // console.log("plantation ->", plantations);
  // console.log("transactions ->", transactions);
  // console.log("activities ->", activities);
  // --- OPTIMIZED useEffect FOR INITIAL LOAD ---
  // useEffect(() => {
  //   const fetchAllInitialData = async () => {
  //     if (!fieldId || !token) {
  //       setLoading(false);
  //       return;
  //     }
  //     setLoading(true);

  //     try {
  //       // We still fetch the main field details separately first, as it's the core data.
  //       const fieldRes = await axios.get(`api/field/${fieldId}`, {
  //         headers: { Authorization: token },
  //       });

  //       if (fieldRes.data.items && fieldRes.data.items.length > 0) {
  //         const fieldDataFromApi = fieldRes.data.items[0];
  //         const boundaries = parseCustomLocationString(
  //           fieldDataFromApi.location
  //         );
  //         setField({ ...fieldDataFromApi, boundaries });

  //         // NOW, fetch all related data concurrently.
  //         // This is much faster than the original waterfall approach.
  //         await Promise.all([
  //           fetchPlantations(),
  //           fetchActivities(),
  //           fetchTransactions(),
  //         ]);
  //       } else {
  //         throw new Error("Field not found.");
  //       }
  //     } catch (error) {
  //       console.error("Failed to fetch field details:", error);
  //       toast.error(t("Could not load field data."));
  //       navigate("/fields");
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   fetchAllInitialData();
  // }, [
  //   fieldId,
  //   token,
  //   navigate,
  //   fetchPlantations,
  //   fetchActivities,
  //   fetchTransactions,
  // ]); // Add callbacks to dependency array

  useEffect(() => {
    const fetchFieldData = async () => {
      if (!fieldId || !token) {
        setLoading(false);
        return;
      }
      setLoading(true);

      try {
        // This effect now only fetches the main field details.
        const fieldRes = await axios.get(`api/field/${fieldId}`, {
          headers: { Authorization: token },
        });

        if (fieldRes.data.items && fieldRes.data.items.length > 0) {
          const fieldDataFromApi = fieldRes.data.items[0];
          const boundaries = parseCustomLocationString(
            fieldDataFromApi.location
          );
          setField({ ...fieldDataFromApi, boundaries });
          // REMOVED: Promise.all() call for other data is gone.
        } else {
          throw new Error("Field not found.");
        }
      } catch (error) {
        console.error("Failed to fetch field details:", error);
        toast.error(t("Could not load field data."));
        navigate("/fields");
      } finally {
        setLoading(false);
      }
    };

    fetchFieldData();
  }, [fieldId, token, navigate, t]); // Simplified dependency array

  // handle delete mock
  //   const handleDeleteConfirmField = () => {
  //     // In a real app, you would make an API call to delete the field
  //     alert(`Field "${field.name}" has been deleted.`);
  //     setDeleteModalOpen(false);
  //     navigate("/fields"); // Navigate back to the list after deletion
  //   };

  // handle delete backend integration
  const handleDeleteConfirmField = async () => {
    // Check if we have the necessary token and fieldId
    if (!token || !fieldId) {
      toast.error(t("Cannot perform deletion: Missing token or Field ID."));
      return;
    }

    try {
      // Make the DELETE request to the backend
      await axios.delete(`api/field/${fieldId}`, {
        headers: {
          Authorization: `${token}`,
        },
      });

      toast.success(
        `${"Field"} "${field.name}" ${t("has been deleted successfully.")}`
      );
      setDeleteModalOpen(false);
      navigate("/fields"); // Navigate back to the list after deletion
    } catch (error) {
      console.error("Failed to delete field:", error);
      toast.error(t("An error occurred while deleting the field."));
    }
  };

  if (loading)
    return <div className="page-message">{t("Loading Field Details...")}</div>;
  if (!field)
    return <div className="page-message error">{t("Field not found.")}</div>;

  const center = field.boundaries.reduce(
    (acc, curr) => [
      acc[0] + curr[0] / field.boundaries.length,
      acc[1] + curr[1] / field.boundaries.length,
    ],
    [0, 0]
  );

  const renderTabContent = () => {
    switch (activeTab) {
      case "details":
        return <DetailsTab field={field} />;
      case "crops":
        // Props are now simpler, just passing IDs and token.
        return <CropsTab fieldId={field.id} token={token} />;
      case "financials":
        // Props are now simpler.
        return <FinancialsTab fieldId={field.id} token={token} />;
      case "satellite":
        return <SatelliteTab field={field} />;
      case "Depreciation":
        return (
          <DepreciationTab
            fieldId={field.id}
            farmId={field.farmId}
            token={token}
          />
        );
      default:
        return null;
    }
  };

  return (
    <div className="details-container">
      <DeleteModal
        isOpen={isDeleteModalOpen}
        onClose={() => setDeleteModalOpen(false)}
        onConfirm={handleDeleteConfirmField}
        itemName={field?.name}
      />

      <header className="view-header">
        <div className="view-header-title-group">
          <h1>{field.name}</h1>
        </div>
        <div className="view-header-actions">
          <button
            className="button-edit"
            onClick={() => navigate(`/fields/${fieldId}/edit/map`)}
          >
            <FaPen /> {t("Edit Field")}
          </button>
          <button
            className="button-danger-outline"
            onClick={() => setDeleteModalOpen(true)}
          >
            <FaTrash /> {t("Delete Field")}
          </button>
        </div>
      </header>

      <div className="details-map-container">
        <MapContainer
          center={center}
          scrollWheelZoom={false}
          dragging={false}
          doubleClickZoom={false}
          zoomControl={false}
          touchZoom={false}
          keyboard={false}
          boxZoom={false}
          attributionControl={false}
        >
          <TileLayer
            url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
            attribution="&copy; Esri"
          />
          <Polygon
            positions={field.boundaries}
            pathOptions={{ color: "#c7356c", dashArray: "5, 5" }}
          />
          <AutoFitBounds bounds={field.boundaries} />
        </MapContainer>
      </div>

      <div className="details-card">
        <div className="tabs">
          <button
            className={`tab-button ${activeTab === "crops" ? "active" : ""}`}
            onClick={() => setActiveTab("crops")}
          >
            {t("Crops")}
          </button>
          <button
            className={`tab-button ${activeTab === "details" ? "active" : ""}`}
            onClick={() => setActiveTab("details")}
          >
            {t("Details")}
          </button>
          <button
            className={`tab-button ${
              activeTab === "financials" ? "active" : ""
            }`}
            onClick={() => setActiveTab("financials")}
          >
            {t("Financial Transactions")}
          </button>
          <button
            className={`tab-button ${
              activeTab === "satellite" ? "active" : ""
            }`}
            onClick={() => setActiveTab("satellite")}
          >
            {t("Satellite")}
          </button>
          <button
            className={`tab-button ${
              activeTab === "Depreciation" ? "active" : ""
            }`}
            onClick={() => setActiveTab("Depreciation")}
          >
            {t("Consumes")}
          </button>
        </div>
        <div className="tab-content">{renderTabContent()}</div>
      </div>
    </div>
  );
};
export { DeleteModal };
export default FieldDetails;
